/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import RadioButtonComponent from "../../../shared-ui/radio-button";
import WhyAskingPopup from "../../../shared-ui/popup/why-asking-popup";
import WhyAskingComponent from "../../../shared-ui/why-asking";
import { getUpdatedOptionsList } from "../../../../utils/optionsList";
import _ from "lodash";
import {
  setUserResponse,
  getPreFillDataByContentKey,
} from "../../../../utils/userResponse";
import { getAllRestrictions } from "../../../../services/suggesticServices";

//import BannerError from "../../../shared-ui/errors/error-banner";

// Interface single selection Component Props
interface SingleSelectionComponentProps {
  questionTitle: string;
  questionSubTitle?: string;
  optionsList: string[];
  optionName: string;
  isEmptySelected: boolean;
  errorMsg: any;
  whyQuestionList: [];
  handleChildContinue?: any;
  handleSuccessfulContinue: any;
  recoId: any;
  contentTypeId: any;
  dependent: any;
  cmDependent: any;
  t?: any;
  disableAutoForward: boolean;
}

interface SingleSelectionComponentState {
  isSelected: boolean;
  isPopupOpen: boolean;
  isEmptySelected: boolean;
  listOfAnswers: any[];
  //displayBanner: boolean;
  questionTitleState: string;
}

/**
 * Used for answer type is in a single selection.
 *
 * @namespace SingleSelectionComponent
 */
class SingleSelectionComponent extends React.Component<
  SingleSelectionComponentProps,
  SingleSelectionComponentState
> {
  constructor(props: SingleSelectionComponentProps) {
    super(props);
    this.state = {
      isSelected: false,
      isPopupOpen: false,
      isEmptySelected: false,
      listOfAnswers: [],
      //displayBanner: false,
      questionTitleState: "",
    };
  }
  componentDidMount = () => {
    this.props.handleChildContinue(this.handleError);
    let recoValuesData: any = getPreFillDataByContentKey(
      this.props.contentTypeId
    );
    if (recoValuesData && !_.isEmpty(recoValuesData)) {
      this.setPreFillData(recoValuesData);
    } else {
      const data: any = getUpdatedOptionsList(this.props.optionsList);
      data.forEach(function (item: { isChecked: boolean }) {
        item.isChecked = false;
      });
      this.setState({
        listOfAnswers: data,
        questionTitleState: this.props.questionTitle,
      });
    }
    //suggestic call
    // getAllRestrictions()
  };
  // componentDidUpdate = () => {
  //   const { optionsList } = this.props;
  //   const { listOfAnswers } = this.state;
  //   let data: any = getUpdatedOptionsList(optionsList);
  //   data.forEach(function (item: { isChecked: boolean }) {
  //     item.isChecked = false;
  //   });
  //   let listOfAnswersProps = data.map(function (element: any) {
  //     return element.value;
  //   });
  //   let listOfAnswersState = listOfAnswers.map(function (element: any) {
  //     return element.value;
  //   });
  //   let equal = _.isEqual(listOfAnswersProps, listOfAnswersState);
  //   if (!equal) {
  //     this.setState({
  //       listOfAnswers: data,
  //       isSelected: false,
  //       isEmptySelected: false,
  //       displayBanner: false,
  //     });
  //   }
  // };

  componentDidUpdate = () => {
    const { optionsList } = this.props;

    let data: any = getUpdatedOptionsList(optionsList);
    data.forEach(function (item: { isChecked: boolean }) {
      item.isChecked = false;
    });
    if (this.props.questionTitle !== this.state.questionTitleState) {
      this.setState({
        listOfAnswers: data,
        isSelected: false,
        isEmptySelected: false,
        // displayBanner: false,
        questionTitleState: this.props.questionTitle,
      });
      let recoValuesData: any = getPreFillDataByContentKey(
        this.props.contentTypeId
      );
      if (recoValuesData) {
        this.setPreFillData(recoValuesData);
      }
    }
  };

  /**
   * This method is used for handleAsking Popup open
   *
   */
  handlePopup = () => {
    this.setState({
      isPopupOpen: true,
    });
  };

  /**
   * This method is used for handleAsking Popup close
   *
   */
  closePopup = () => {
    this.setState({
      isPopupOpen: false,
    });
  };

  /**
   * Used to set data as per users input(existing- if any)
   */
  setPreFillData = (recoValuesData: any) => {
    const data: any = getUpdatedOptionsList(this.props.optionsList);
    data.forEach((item: any) => {
      if (item.id === recoValuesData.recoValues) {
        item.isChecked = true;
      } else {
        item.isChecked = false;
      }
    });
    this.setState({
      isSelected: true,
      isEmptySelected: false,
      listOfAnswers: data,
    });
  };

  /**
   * This method is used for handling errors
   */
  handleError = () => {
    if (this.state.isSelected === true) {
      this.setState(
        {
          isEmptySelected: false,
          isSelected: false,
          // displayBanner: false,
        },
        () => {
          if (this.props.dependent || this.props.cmDependent) {
            const data: any = this.getSelectedData();
            if (this.props.cmDependent && this.props.dependent) {
              const { conditions, dependent_content_type_id } =
                this.props.dependent;
              const selectedValue = data?.recoValues;
              let isValueFound = _.includes(conditions, selectedValue);
              const addRemoveData = this.handleAddRemoveCm();
              if (isValueFound) {
                addRemoveData.valuesToRemove = _.union(
                  dependent_content_type_id,
                  addRemoveData.valuesToRemove
                );
              } else {
                addRemoveData.valuesToAdd = _.union(
                  dependent_content_type_id,
                  addRemoveData.valuesToAdd
                );
              }
              this.props.handleSuccessfulContinue(
                false,
                false,
                false,
                false,
                true,
                addRemoveData.valuesToAdd,
                addRemoveData.valuesToRemove
              );
            } else {
              if (this.props.dependent) {
                const { conditions, dependent_content_type_id } =
                  this.props.dependent;
                const selectedValue = data?.recoValues;
                let isValueFound = _.includes(conditions, selectedValue);
                this.props.handleSuccessfulContinue(
                  false,
                  false,
                  dependent_content_type_id,
                  isValueFound,
                  false,
                  false,
                  false
                );
              }
              if (this.props.cmDependent) {
                const addRemoveData = this.handleAddRemoveCm();
                this.props.handleSuccessfulContinue(
                  false,
                  false,
                  false,
                  false,
                  true,
                  addRemoveData.valuesToAdd,
                  addRemoveData.valuesToRemove
                );
              }
            }
          } else {
            this.getSelectedData();
            this.props.handleSuccessfulContinue();
          }
        }
      );
    } else {
      this.setState({
        isEmptySelected: true,
        //displayBanner: true,
        // errorMsg: empty_error,
      });
    }
  };

  /**
   *
   * @returns
   */
  handleAddRemoveCm = () => {
    const cmDepList: any = this.props.cmDependent;
    const data: any = this.getSelectedData();
    const selectedValue = data?.recoValues;
    let valuesToAdd: any = [];
    let valuesToRemove: any = [];
    _.map(cmDepList, (eachData: any) => {
      if (
        !_.isEmpty(eachData.conditions) &&
        !_.isEmpty(eachData.dependent_content_type_id)
      ) {
        let isCmValueFound = _.includes(eachData.conditions, selectedValue);
        if (isCmValueFound) {
          valuesToRemove.push(...eachData.dependent_content_type_id);
        } else {
          valuesToAdd.push(...eachData.dependent_content_type_id);
        }
      }
    });
    let cmData: any = {
      valuesToAdd: valuesToAdd,
      valuesToRemove: valuesToRemove,
    };
    return cmData;
  };

  /**
   * @Name - getSelectedData
   * @Desc - This is used to find user response from options list
   *          and send to store.
   */
  getSelectedData = () => {
    let responseData: Object = {};
    _.map(this.state.listOfAnswers, (data) => {
      if (data?.isChecked) {
        responseData = {
          contentTypeId: this.props.contentTypeId,
          recoId: this.props.recoId,
          recoValues: data.id,
          values: data.value,
        };
      }
    });

    setUserResponse(responseData);
    return responseData;
  };

  handleChange = (value: any) => {
    let data: any = this.state.listOfAnswers;
    data.forEach((item: any) => {
      if (item.value === value) {
        item.isChecked = true;
        this.setState(
          {
            isSelected: true,
            isEmptySelected: false,
            //displayBanner: false,
            listOfAnswers: data,
          },
          () => {
            !this.props.disableAutoForward && this.handleError();
          }
        );
      } else {
        item.isChecked = false;
      }
    });
  };

  render() {
    const { listOfAnswers /*, displayBanner*/ } = this.state;
    const {
      questionTitle,
      questionSubTitle,
      optionName,
      whyQuestionList,
      errorMsg,
    } = this.props;
    const { empty_error } = errorMsg;

    return (
      <>
        {/*This code will be used if error in banner is needed */}
        {/* {displayBanner ? (
          <>
            <BannerError
              title={this.props.t("error.we_would_like_to_know_this")}
              sub_title={this.props.t("error.please_select_one_of_the_options")}
              handleClose={() => {
                this.setState({
                  displayBanner: false,
                  isSelected: false,
                  isEmptySelected: false,
                });
              }}
            />
          </>
        ) : null} */}
        <div className="inner-wrapper" /*style={{ position: "absolute" }}*/>
          <WhyAskingPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            list={whyQuestionList}
          />
          <div className="question-wrappper">
            <div className="question-label">{questionTitle || ""}</div>
            <div className="question-sub-label">{questionSubTitle || ""}</div>
          </div>
          <RadioButtonComponent
            optionsList={listOfAnswers}
            optionName={optionName}
            handleRadioButtonChange={(value: any) => {
              this.handleChange(value);
            }}
            isEmptySelected={this.state.isEmptySelected}
            errorMsg={empty_error || ""}
          />
          {whyQuestionList && whyQuestionList.length > 0 ? (
            <WhyAskingComponent
              {...this.props}
              handlePopup={this.handlePopup}
            />
          ) : null}
        </div>
      </>
    );
  }
}

export default SingleSelectionComponent;
